import React from "react"
import './Footer.css';


export default function Footer()
{
return(
        <footer>
            <p>© 2022 Legaci. All rights reserved.</p>
        </footer>
)
}